import { t, type I18nLocale } from '@ardoq/i18n';
import type { TripleWarningLabels } from '@ardoq/metamodel-constraints';

export const getTripleWarningLabels = (
  i18nLocale: I18nLocale
): TripleWarningLabels => ({
  metamodelConstraintsInlineLink: t(
    i18nLocale,
    'metamodelConstraints:tripleWarning.metamodelConstraintsInlineLink',
    'metamodel constraints'
  ),
  implicitReferenceTypeWarningWithCount: ({ count, sourceType, targetType }) =>
    count === 1
      ? t(
          i18nLocale,
          'metamodelConstraints:tripleWarning.implicitReferenceTypeWarningWithCountOne',
          { sourceType, targetType },
          'There is 1 approved reference type from "{{sourceType}}" to "{{targetType}}". We recommend using \'Implicit\' only when it doesn\'t match your needs.'
        )
      : t(
          i18nLocale,
          'metamodelConstraints:tripleWarning.implicitReferenceTypeWarningWithCountOther',
          { count, sourceType, targetType },
          'There are {{count}} approved reference types from "{{sourceType}}" to "{{targetType}}". We recommend using \'Implicit\' only when none of them match your needs.'
        ),
  implicitReferenceTypeWarning: t(
    i18nLocale,
    'metamodelConstraints:tripleWarning.implicitReferenceTypeWarning',
    "We recommend using 'Implicit' only when none of the existing reference types match your needs."
  ),
  referenceTypeViolatesConstraintsWarning: ({
    referenceType,
    sourceType,
    targetType,
  }) =>
    t(
      i18nLocale,
      'metamodelConstraints:tripleWarning.referenceTypeViolatesConstraintsWarning',
      { referenceType, sourceType, targetType },
      '"{{referenceType}}" reference type from "{{sourceType}}" to "{{targetType}}" isn\'t approved yet, so this reference may not appear in some views and reports.'
    ),
  referenceNotApprovedAdminDetail: t(
    i18nLocale,
    'metamodelConstraints:tripleWarning.referenceNotApprovedAdminDetail',
    'If this seems like a valid path, add it to your'
  ),
  referenceNotApprovedNonAdminDetail: t(
    i18nLocale,
    'metamodelConstraints:tripleWarning.referenceNotApprovedNonAdminDetail',
    'If this seems like a valid path, contact your admin to get it approved in the'
  ),
});
